module.exports = __webpack_public_path__ + "media/images/wave_green-816b54b2.svg";